import script from "./IndexTypography.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexTypography.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__